import { Box, Button } from "@mui/material";
import React from "react";

import { AccountPageLayout } from "components/common/AccountPageLayout";

import { useTenantTranslation } from "hooks/formatters";
import { useCanEditAndSendDeploy } from "hooks/useCanEditAndSendDeploy";
import { DeployedPlansTable } from "./deployedPlansTable";
import { EditBackupPlanModal } from "./EditBackupPlanModal";
import { Period } from "hooks/periodIndex";

export const DeployedPlansPage = () => {
  const [openEditBackupPlan, setOpenEditBackupPlan] = React.useState(false);
  const { t } = useTenantTranslation();
  const canEditAndSendDeploy = useCanEditAndSendDeploy();

  const handleClose = () => {
    setOpenEditBackupPlan(false);
  };

  const handleOpen = () => {
    if (canEditAndSendDeploy) {
      setOpenEditBackupPlan(true);
    }
  };

  return (
    <>
      <AccountPageLayout
        title={t("deployedPlans")}
        actionButton={
          canEditAndSendDeploy ? (
            <Button variant="contained" onClick={handleOpen}>
              {t("editBackupPlan")}
            </Button>
          ) : undefined
        }
      >
        <Box sx={{ mt: 5, mb: 2, minHeight: 0, height: "100%" }}>
          <DeployedPlansTable />
        </Box>
      </AccountPageLayout>
      {canEditAndSendDeploy ? (
        <EditBackupPlanModal
          open={openEditBackupPlan}
          doClose={handleClose}
          period={1 as Period}
        />
      ) : null}
    </>
  );
};
